import { Table } from "antd";
import { UNITS } from "components/Common/Constants";
import NoData from "components/Common/NoData";

const DynoStatisticsTable = ({
  tableData,
}) => {

  const columns = [
    {
      title: "Model Name",
      dataIndex: "model",
      key: "model",
      className: "pl1",
    }
  ];

  tableData?.modeList?.forEach(mode =>
    columns.push({
      title: mode[0] + mode.slice(1).toLowerCase() + " Mode",
      dataIndex: mode,
      key: mode,
      align: "center",
      className: "plr05",
      render: (mode) => `${mode || 0} ${UNITS.PERCENT}`,
    })
  );

  return tableData?.List?.length > 0 ? (
    <Table
      data-testid="eol-dyno-statistics-table"
      columns={columns}
      dataSource={tableData.List}
      rowKey={(record) => record.key}
      scroll={{ x: "100%" }}
      pagination={false}
      className="eol-dyno-statistics-table"
    />
  ) : (
    <div className="pd3025" data-testid="empty-eol-dyno-statistics-table">
      <NoData />
    </div>
  );
};
export default DynoStatisticsTable;